import $api from "../Api";
import Endpoints from "../Endpoints";

// Dashboard business errors use the same HTTP 200 envelope as successful data.
// Leave them to the individual panel so one failed report does not hide the others.
async function getReport(url) {
  const response = await $api.get(url);
  if (
    response?.isSuccess !== true ||
    response.message !== "OK" ||
    !response.data
  ) {
    throw new Error(response?.exceptionMessage || response?.message || "FAIL");
  }
  return response;
}

export const GetSummary = (options) =>
  getReport(Endpoints.CrmDashboard.GetSummary(options));
export const GetTrends = (options) =>
  getReport(Endpoints.CrmDashboard.GetTrends(options));
export const GetReactions = (options) =>
  getReport(Endpoints.CrmDashboard.GetReactions(options));
export const GetTagActivity = (options) =>
  getReport(Endpoints.CrmDashboard.GetTagActivity(options));
export const GetPlatformRegions = (options) =>
  getReport(Endpoints.CrmDashboard.GetPlatformRegions(options));
export const GetBrandRegions = (options) =>
  getReport(Endpoints.CrmDashboard.GetBrandRegions(options));

export default {
  GetSummary,
  GetTrends,
  GetReactions,
  GetTagActivity,
  GetPlatformRegions,
  GetBrandRegions,
};
